export const getPickupWeeks = ({ enrollment }) => enrollment.pickupWeeks;
export const getStoredState = ({ enrollment }) => enrollment.storedState;
export const getSaveEnrolment = ({ enrollment }) => enrollment.saveEnrolment;
export const getRegisteredEnrolmentsDates = ({ enrollment }) => enrollment.registeredEnrolmentsDates;
export const getRegisteredEnrolments = ({ enrollment }) => enrollment.registeredEnrolments;
export const getReturnForms = ({enrollment}) => enrollment.returnForms;
